<template>
    <div>
        <van-overlay class-name="manual-list-overlay" :show="overlayShow" @click="overlayShow = false">
            <div class="manual-list-overlay-content" @click.stop>
                <div class="manual-list-overlay-content-main">
                    <span>添加小助手</span>
                    <span class="selected">长按识别二维码，加小助手申领手册</span>
                    <van-image src="/static/bytx/anticancer/QR-code.svg" />
                    <van-image
                        class="close-icon"
                        src="/static/bytx/anticancer/close-icon.svg"
                        @click="overlayShow = false"
                    />
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    data() {
        return {
            overlayShow: false
        }
    }
}
</script>

<style lang="scss" scoped>
.manual-list-overlay-content {
    z-index: 100;
    display: flex;
    justify-content: center;
    padding-top: 134px;

    .manual-list-overlay-content {
        &-main {
            border-radius: 10px;
            width: 285px;
            height: 280px;
            background: #ffffff;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;

            .close-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 20px !important;
                height: 20px !important;

                .van-image__img {
                    width: 20px;
                    height: 20px;
                }
            }
            .van-image {
                width: 140px;
                height: 140px;
            }

            span {
                &:nth-child(1) {
                    font-family: PingFangSC-Semibold;
                    font-size: 14px;
                    color: #282828;
                    letter-spacing: 0;
                    text-align: center;
                    margin-top: 18px;
                    margin-bottom: 1px;
                }

                &:nth-child(2) {
                    font-family: PingFangSC-Regular;
                    font-size: 10px;
                    color: #404040;
                    letter-spacing: 0;
                    text-align: center;
                    margin-top: 12px;
                    margin-bottom: 20px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/overlay/addAssistant.vue